import React from 'react';

import Section from './Section';

export default function Sections({ sections, notLast }) {
  return sections.map((section, i) => (
    <Section key={section.content} {...section} isLast={notLast ? false : i + 1 === sections.length} />
  ))
}
